import React, { useEffect, useState, useMemo } from "react";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import { useMosques, useDeleteMosque } from "api/useMosques.ts";

export default function mosquesTableData() {
  const { data: fetchedMosques, isLoading } = useMosques();
  const deleteMosqueMutation = useDeleteMosque();
  const [notification, setNotification] = useState({
    open: false,
    message: "",
    severity: "success", // "success" | "error"
  });

  const handleCloseNotification = () => {
    setNotification((prev) => ({ ...prev, open: false }));
  };

  const handleDeleteMosque = async (mosqueId) => {
    try {
      await deleteMosqueMutation.mutateAsync(mosqueId);
      setNotification({
        open: true,
        message: "Mosque deleted successfully",
        severity: "success",
      });
    } catch (error) {
      console.error("Error deleting mosque:", error);
      setNotification({
        open: true,
        message: "Failed to delete mosque",
        severity: "error",
      });
    }
  };

  const rows = useMemo(() => {
    return isLoading
      ? Array(10)
          .fill(0)
          .map((_, index) => ({
            mosqueId: index + 1,
            mosqueName: "Loading...",
            address: "Loading...",
            location: "Loading...",
            action: <div className="flex justify-center space-x-2">Loading...</div>,
          }))
      : fetchedMosques?.map((mosque) => ({
          mosqueId: mosque._id,
          mosqueName: mosque.name || "N/A",
          address: mosque.address || "N/A",
          location:
            Array.isArray(mosque.location?.coordinates) && mosque.location.coordinates.length === 2
              ? `${mosque.location.coordinates[0]}, ${mosque.location.coordinates[1]}`
              : "N/A",
          action: (
            <div className="flex justify-center space-x-2">
              <IconButton
                color="error"
                size="medium"
                onClick={() => handleDeleteMosque(mosque._id)}
                disabled={deleteMosqueMutation.isPending}
              >
                <DeleteIcon fontSize="medium" />
              </IconButton>
            </div>
          ),
        }));
  }, [isLoading, deleteMosqueMutation.isPending]);

  return {
    columns: [
      { Header: "ID", accessor: "mosqueId", align: "center" },
      { Header: "Mosque Name", accessor: "mosqueName", align: "center" },
      { Header: "Address", accessor: "address", align: "center" },
      { Header: "Location", accessor: "location", align: "center" },
      { Header: "Actions", accessor: "action", align: "center" },
    ],
    rows,
    notification,
    setNotification,
    handleCloseNotification,
  };
}
